<template>
<div class="row m-0 my-2 p-0 justify-content-start align-items-center">
	<pick-year-vidget
		v-model:year="currentYear"
		:is-request-active="isRequestActive"
	/>
</div>

<div class="row m-0">
	<div
		v-if="currentYear"
		class="half-transparent-border widget-7x5 chart-widget"
	>
		<StationCircuitHeatmap
			:station-id="stationId"
			:metricName="boxDoorMetricName"
			:year="currentYear"
			@selected-day="onClickDay"
		/>
	</div>
	<div
		v-else
		class="half-transparent-border widget-7x5 chart-widget"
	>
		<div class="d-flex flex-column justify-content-center align-items-center h-100">
			&nbsp;
		</div>
	</div>
</div>

<div class="row m-0 my-2 mt-4 justify-content-start align-items-center">
	<!-- Previous day button -->
	<div class="col-auto m-0 g-0 p-0 me-2 ">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0 me-2"
			@click="showPreviousDay"
			:disabled="isRequestActive"
		>
			<button-icon icon="triangle-left" fill="currentColor" />
		</button>
	</div>
	<!-- Day input field -->
	<div class="col-auto m-0 g-0 p-0 me-2">
		<input
			:value="selectedDay == null ? chartDateStr(new Date()) : chartDateStr(selectedDay)"
			type="text"
			class="form-control form-control-sm"
			style="width: 13ch; text-align: center;"
			readonly
		/>
	</div>
	<!-- Next day button -->
	<div class="col-auto m-0 g-0 p-0 me-2 ">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm mx-1 ms-2"
			@click="showNextDay"
			:disabled="isSelectCurrentDay || isRequestActive"
		>
			<button-icon icon="triangle-right" fill="currentColor" />
		</button>
	</div>
	<div class="col-auto m-0 g-0 p-0 ms-2 me-2 ">
		<div
			v-show="isRequestActive"
			class="spinner-border text-secondary"
			role="status"
			style="width: 1.7rem; height: 1.7rem;"
		>
			<span class="visually-hidden">Loading...</span>
		</div>
	</div>
</div>

<div class="row m-0">
	<div
		v-if="currentYear"
		class="half-transparent-border widget-7x5 chart-widget"
	>
		<StationCircuitChart
			:station-id="stationId"
			:metricName="boxDoorMetricName"
			:date="selectedDay"
		/>
	</div>
	<div
		v-else
		class="half-transparent-border widget-7x5 chart-widget"
	>
		<div class="d-flex flex-column justify-content-center align-items-center h-100">
			&nbsp;
		</div>
	</div>
</div>
</template>




<script>
import StationCircuitHeatmap from '@/components/Charts/StationCircuitHeatmap.vue'
import StationCircuitChart from '@/components/Charts/StationCircuitChart.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import PickYearVidget from '@/components/Vidgets/PickYearVidget.vue'
import { INFLUXDB } from '@/api/api.js'
import {
	chartDateStr,
	firstYearDay,
	lastYearDay,
} from '@/helpers.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useStationsHistoryStore } from '@/stores/StationsHistoryStore.js'
import { Station } from '@/models/station.js'
import { ServiceUnit } from '@/models/serviceUnit.js'


export default {
	components: {
		StationCircuitHeatmap,
		StationCircuitChart,
		ButtonIcon,
		PickYearVidget,
	},


	props: {
		stationId: {
			type: String,
			require: true,
		},
	},


	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const historyStore = useStationsHistoryStore()

		return {
			accountStore,
			stationsStore,
			historyStore,
			INFLUXDB,
			Station,
			ServiceUnit,
			chartDateStr,
		}
	},


	data() {
		return {
			currentYear: null,
			selectedDay: null,
		}
	},


	async created() {
		this.currentYear = Number((new Date()).getFullYear())
		// Load curent year metrics
		await this.historyStore.loadMetrics(
				this.metricsId,
				[
					[INFLUXDB.station_metrics.service_unit,	this.boxDoorMetricName],
					[INFLUXDB.station_metrics.service_unit, ServiceUnit.metricKeys.isConnect],
				],
				firstYearDay(this.currentYear),
				lastYearDay(this.currentYear),
				true,
			)
	},

	mounted() {},

	methods: {
		showPreviousDay() {
			const selectedDate = this.selectedDay == null ? new Date() : this.selectedDay
			this.selectedDay = new Date(selectedDate.getTime() - (24 * 3600 * 1000))
		},

		showNextDay() {
			const selectedDate = this.selectedDay == null ? new Date() : this.selectedDay
			this.selectedDay = new Date(selectedDate.getTime() + (24 * 3600 * 1000))
		},

		onClickDay(date) {
			//console.log('Click on day', date)
			this.selectedDay = new Date(date)
		},
	},


	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		metricsId() { return this.station.passport.get(Station.passportKeys.metricsId) },

		boxDoorMetricName() {
			return ServiceUnit.metricKeys.fSecurityCircuitBoxDoor
		},

		isRequestActive() {
			return this.historyStore.activeRequestsCounter > 0
		},

		isSelectCurrentDay() {
			if (this.selectedDay == null) {
				return true
			}

			const selectedYear = this.selectedDay.getFullYear()
			const nowDate = new Date()
			const nowYear = nowDate.getFullYear()

			if (selectedYear != nowYear) {
				return false
			}

			const selectedDayOfYear = Math.floor(
				(this.selectedDay - new Date(selectedYear, 0, 0)) / (1000 * 60 * 60 * 24)
			)
			const nowDayOfYear = Math.floor(
				(nowDate - new Date(nowDate.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24)
			)

			return selectedDayOfYear == nowDayOfYear
		},
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style scoped>
	/* Remove arrows from input Chrome, Safari, Edge, Opera */
	input.no-arrow::-webkit-outer-spin-button,
	input.no-arrow::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Remove arrows from input Firefox */
	input[type=number].no-arrow {
		appearance: textfield;
		-moz-appearance: textfield;
	}

	.input-min-width {
		min-width: 43ch; 
		max-width: 56ch;
		width: 100%;
	}

	.chart-widget {
		height: 260px; min-width: 600px;
	}

	.load-spinner {
		width: 7rem;
		height: 7rem;
	}
</style>